import { Box, ButtonBase, useTheme } from "@mui/material";

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import NightsStayOutlinedIcon from '@mui/icons-material/NightsStayOutlined';
import PublicIcon from '@mui/icons-material/Public';
import WorkspacesIcon from '@mui/icons-material/Workspaces';

import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage, setSelectedMenuItem, setThemeMode } from "../../../../newapi/global/settingsSlice";
import { tokens } from "../../../../theme";
import { localeSettings, nextLocale } from "../../../../utils/locales";
import ShSwitch from "../../../theme/inputs/ShSwitch";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import Text from "../../../theme/text/Text";
import { ShCopyButtonWithOwnChildren } from "../../../theme/ShCopy";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ENV_TYPES } from "../../Sidebar";
import MSelectWorkspaces from "../MSelectWorkspaces";
import { ActionButton } from "./components/ActionButton";
import { ActionIcon } from "./components/ActionIcon";
import { selectUser } from "../../../../newapi/user/authentication/authSlice";
import { useGetSettingsQuery } from "../../../../newapi/global/generalApiSlice";
import LaunchIcon from '@mui/icons-material/Launch';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useNavigate } from "react-router-dom";
import cx from 'classnames';
import UpgradeOutlinedIcon from '@mui/icons-material/UpgradeOutlined';

const TopbarActionModal = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const language = useSelector((state) => state.settings.language);
    const workSpace = useSelector((state) => state.settings.workSpace);
    const themeMode = useSelector((state) => state.settings.themeMode);
    const selectedMenuItem = useSelector((state) => state.settings.environment.selectedMenuItem);
    
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const user = useSelector(selectUser);

    const [open, setOpen] = useState(false);
    const [swVersion, setSwVersion] = useState(null);

    // Ask the active service worker for its cache name (the running version) so it
    // can be shown here and copied to the clipboard when opening the help center.
    useEffect(() => {
        if (!('serviceWorker' in navigator)) return;
        let cancelled = false;
        const askVersion = (sw) => {
            if (!sw) return;
            const channel = new MessageChannel();
            channel.port1.onmessage = (event) => {
                if (!cancelled && event.data?.version) setSwVersion(event.data.version);
            };
            sw.postMessage({ type: 'GET_VERSION' }, [channel.port2]);
        };
        const query = () => {
            if (navigator.serviceWorker.controller) {
                askVersion(navigator.serviceWorker.controller);
            } else {
                navigator.serviceWorker.ready.then((reg) => askVersion(reg.active)).catch(() => {});
            }
        };
        query();
        // The controller changes after an update (skipWaiting + clients.claim);
        // re-query then so the version appears without a manual reload.
        navigator.serviceWorker.addEventListener('controllerchange', query);
        return () => {
            cancelled = true;
            navigator.serviceWorker.removeEventListener('controllerchange', query);
        };
    }, []);

    const copyVersion = () => {
        if (swVersion && navigator.clipboard) {
            navigator.clipboard.writeText(swVersion).catch(() => {});
        }
    };

    const { data: settings} = useGetSettingsQuery("general");
    const externalLinkValue = settings?.find(setting => setting.key === "general_external_knowledgebase")?.value;
    const hasExternalLink = typeof externalLinkValue !== 'undefined' && externalLinkValue !== null && externalLinkValue.length > 0;

    const workSpaceModal = {
        open: open,
        setOpen: setOpen
    }

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    
    const toggleColor = () => {
        dispatch(setThemeMode(themeMode === "dark" ? "light" : "dark"));
        document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#181820": "#ecf0f5"}`);
        document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#181820": "#ecf0f5"}`);
    }

    const toggleLanguage = () => {
        dispatch(setLanguage(nextLocale(language)));
    }


    const handleUpdateClick = () => {
        if (window.forceUpdatePWA) {
            window.forceUpdatePWA();
        } else {
            console.log("Service worker update function is not available.");
        }
    };

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >

                <Box
                    sx={{
                        height:40,
                        borderRadius:5,

                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        px:0.5,
                        display:"none",
                        alignItems:'center',
                        mb:1,
                        mt:1,
                        "@media screen and (max-width: 47.9375em)" : {
                            display:'flex',
                         }
                    }}
                >
                    
                    {selectedEnvironmentType === ENV_TYPES[100] ?
                        <ButtonBase
                            onClick={() => {
                                {selectedEnvironmentType === ENV_TYPES[100] &&
                                    workSpaceModal.setOpen(true)
                                }
                            }}
                            sx={{
                                width:1,
                                height:32,
                                display:"flex",
                                alignItems:'center',
                                justifyContent:'flex-start',
                                borderRadius:5,
                                pr:3,
                                transition:"250ms",
                                "&:hover" : {
                                    transition:"250ms",
                                    background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100]
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    background:theme.palette.mode === "dark" ? colors.blue[100]  : colors.primary[100],
                                    width:32,
                                    height:32,
                                    borderRadius:20,
                                    padding:0,
                                    minWidth:0,
                                    boxShadow:"none",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:'center',
                                    transition:"250ms",
                                    color:theme.palette.mode === "dark" ? colors.blue[400]  : colors.primary[400],
                                }}
                            >
                                <PersonOutlinedIcon/>

                            </Box>
                            <Box
                                sx={{
                                    ml:1,
                                    display:'flex',
                                    flexDirection:'column',
                                    maxWidth:140,
                                }}
                            >

                                <Text noBreak fontSize={14} bold>{user?.name}</Text>
                                <Text fontSize={12} noBreak>
                                    {workSpace.id === -1 ? t(workSpace?.name) : workSpace?.name}
                                </Text>
                            </Box>
                        </ButtonBase>
                    :
                        <Box
                            sx={{
                                height:32,
                                display:"flex",
                                alignItems:'center',
                                pl:0.5,
                                borderRadius:5,
                                pr:3,
                            }}
                        >
                            <Box
                                sx={{
                                    background:theme.palette.mode === "dark" ? colors.blue[100]  : colors.primary[100],
                                    width:32,
                                    height:32,
                                    borderRadius:20,
                                    padding:0,
                                    minWidth:0,
                                    boxShadow:"none",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:'center',
                                    transition:"250ms",
                                    color:theme.palette.mode === "dark" ? colors.blue[400]  : colors.primary[400],
                                }}
                            >
                                <PersonOutlinedIcon/>
                            </Box>
                            <Box
                                sx={{
                                    ml:1,
                                    display:'flex',
                                    flexDirection:'column',
                                    maxWidth:140,
                                }}
                            >

                                <Text noBreak fontSize={14} bold>{user?.name}</Text>
                            </Box>
                        </Box>
                    }

                </Box>
               

                

                {/* Desktop has the flag picker in the topbar; this row only serves mobile. */}
                <ActionButton
                    onClick={toggleLanguage}
                    sx={{
                        display:"none",
                        "@media screen and (max-width: 47.9375em)" : {
                            display:"flex",
                        }
                    }}
                >
                    <ActionIcon>
                        <PublicIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text light>
                            {t('language')}:&nbsp;
                        </Text>
                        <Text>
                            {localeSettings[language].language}
                            {/* {localeSettings[language].language} */}
                        </Text>
                    </Box>
                    <Box
                        sx={{
                            marginLeft:"auto",
                            display:"flex",
                            alignItems:"center"
                        }}
                    >
                        {localeSettings[language].flag}
                    </Box>
                </ActionButton>
                

                <ActionButton
                    onClick={toggleColor}
                >
                    <ActionIcon>
                        {/* <DarkModeOutlinedIcon fontSize="small"/> */}
                        {themeMode === 'dark' ? (
                            <NightsStayIcon fontSize="small"/>
                        ) : (
                            <NightsStayOutlinedIcon fontSize="small"/>
                        )}
                    </ActionIcon>
                    <Text medium>
                        {t('night_mode')}
                        {/* {theme.palette.mode === 'dark' ? (
                            "Nacht modus"
                        ) : (
                            "Dag modus"
                        )} */}
                    </Text>
                    <Box
                        sx={{
                            marginLeft:"auto",
                            marginRight:"-8px"
                        }}
                    >
                        <ShSwitch
                            checked={themeMode === "dark"}
                            color="blue"
                        ></ShSwitch>
                    </Box>
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        // Copy the running version first so it's ready to paste in a support request.
                        copyVersion();
                        window.open('https://stockhubsupport.zendesk.com/hc/nl', '_blank');
                    }}
                >
                    <ActionIcon>
                        <HelpOutlineOutlinedIcon fontSize="small" />
                    </ActionIcon>
                    <Text medium>
                        {t('help_center')}
                    </Text>
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        window.open('https://stockhub.nl/algemene-voorwaarden/', '_blank');
                    }}
                >
                    <ActionIcon>
                        <DescriptionOutlinedIcon fontSize="small" />
                    </ActionIcon>
                    <Text medium>
                        {t('terms_and_conditions')}
                    </Text>
                </ActionButton>
                {hasExternalLink &&
                    <ActionButton
                        onClick={() => {
                            window.open(externalLinkValue, '_blank');
                        }}
                    >
                        <ActionIcon>
                            <LaunchIcon fontSize="small" />
                        </ActionIcon>
                        <Text medium>
                            {t('external_help_center')}
                        </Text>
                    </ActionButton>
                }
                
                {swVersion &&
                    <ShCopyButtonWithOwnChildren
                        value={swVersion}
                        closeAfter={1500}
                        sx={{
                            height:32,
                            borderRadius:4,
                            display:"flex",
                            alignItems:"center",
                            pl:1.5,
                            pr:1.5,
                            gap:2,
                            cursor:"pointer",
                            overflow:"hidden",
                            // Give the pill a definite width capped at the menu width (ActionButton
                            // is minWidth 250) so a long version ellipsizes inside the flex slot
                            // below instead of widening the whole popover.
                            width:1,
                            maxWidth:250,
                            background: theme.palette.mode === "dark" ? colors.white[100] : colors.grey[100],
                        }}
                    >
                        <InfoOutlinedIcon fontSize="small" sx={{flexShrink:0, color:colors.txt["secondary"]}}/>
                        <Box
                            sx={{
                                flex:1,
                                minWidth:0,
                                overflow:"hidden",
                                whiteSpace:"nowrap",
                                textOverflow:"ellipsis",
                                fontFamily:"Roboto, sans-serif",
                                fontSize:13,
                                color:colors.txt["primary"],
                            }}
                        >
                            {swVersion}
                        </Box>
                        <ContentCopyOutlinedIcon fontSize="small" sx={{flexShrink:0, color:colors.txt["secondary"]}}/>
                    </ShCopyButtonWithOwnChildren>
                }
                {/* <ActionButton
                    onClick={handleUpdateClick}
                >
                    <ActionIcon>
                        <UpgradeOutlinedIcon fontSize="small" />
                    </ActionIcon>
                    <Text medium>
                        {t('update_stockhub')}
                    </Text>
                </ActionButton> */}
                {user?.sha &&
                    <ButtonBase
                        className={cx('',{
                            'active': selectedMenuItem === "warehouse-settings-setup",
                        })}
                        onClick={() => {
                            navigate("/warehouse/settings/setup");
                            dispatch(setSelectedMenuItem("warehouse-settings-setup"));
                            if(props.onClose){
                                props.onClose();
                            }
                        }}
                        sx={{
                            width: 1,
                            height: 40,
                            minHeight:40,
                            borderRadius: "8px",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            pl:1,
                            cursor: "pointer",
                            background: "linear-gradient(to right, #0D61FF 60%, #8DB5FF)",
                            backgroundSize: "150% 100%",
                            backgroundPosition: "right center",
                            transition: "background-position 0.5s ease",
                            fontWeight:"500",
                            fontFamily:"Roboto, sans-serif",
                            fontSize:15,
                            "& .icon": {
                                width:32,
                                minWidth:32,
                                flexShrink:0,
                                mr:1,
                                "& path" : {
                                    fill: "rgba(255,255,255,.55)",
                                    transition:"250ms",

                                }

                            },
                            "&:hover": {
                                backgroundPosition: "left center",

                                "& .icon": {
                                    "& path" : {
                                        fill: "rgba(255,255,255,1)",
                                        transition:"250ms",

                                    }

                                },
                            },
                            "&.active" : {
                                background: theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : colors.grey[100],
                                color: colors.txt["primary"],
                                "& .icon": {
                                    "& path" : {
                                        fill: colors.txt["primary"],
                                        // fill: "rgba(255,255,255,1)",

                                    }

                                },
                            }
                        }}
                    >
                        <SettingsOutlinedIcon className='icon'/>
                        {t("setup_panel")}
                    </ButtonBase>
                }
            </Box>
            <MSelectWorkspaces
                open={workSpaceModal.open} 
                handleClose={() => workSpaceModal.setOpen(false)}
            />

        </PopoverModal>
    );
}

export default TopbarActionModal;